module.exports = __webpack_public_path__ + "static/kad-library-fa06d42f27ed66d48a975c8f33bb8b61.png";